var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 185C143.586 185 185 143.586 185 92.5C185 41.4137 143.586 0 92.5 0C41.4137 0 0 41.4137 0 92.5C0 143.586 41.4137 185 92.5 185Z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158 112.734C158 110.571 156.911 108.764 155.362 107.869V74.3105C155.713 74.1554 155.932 73.7674 155.928 73.3339C155.928 72.9003 155.686 72.5169 155.346 72.3754L96.1347 47.954C95.3775 47.639 94.5501 47.639 93.789 47.954L34.5855 72.38C34.2381 72.5215 34.004 72.9049 34.0001 73.3384C33.9961 73.772 34.2186 74.1599 34.5621 74.3151L93.6837 101.224C94.5072 101.594 95.4166 101.594 96.2401 101.224L151.279 76.1589V107.864C149.734 108.754 148.645 110.575 148.645 112.725C148.645 114.97 149.816 116.919 151.49 117.754C149.816 121.62 148.645 129.552 148.645 131.816C148.645 134.833 150.741 137.279 153.32 137.279C155.896 137.279 157.992 134.833 157.992 131.816C157.992 129.552 156.817 121.62 155.147 117.754C156.825 116.928 158 114.98 158 112.734Z",
    fill: "#DD6F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0776 87.8652C53.0815 95.6056 53.0854 104.715 53.0854 106.162C53.0854 120.575 71.6361 132.309 94.9639 133.043C118.288 132.309 136.838 120.588 136.838 106.162C136.838 104.724 136.838 95.6102 136.846 87.8652L96.2323 106.354C95.4088 106.728 94.4994 106.728 93.6759 106.354L53.0776 87.8652Z",
    fill: "#DD6F69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 145,
    fill: "white",
    transform: "translate(34 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/Learning.bdfa0926f54a6648d0a28260c8839ffe.svg";
export { ForwardRef as ReactComponent };